<template>
  <DropDownMenu
    :bottomAlign="bottomAlign"
    :class="$style.exportDropDown"
    :disabled="disabled"
    :menuSections="menuSections"
    menuTitle="export"
    :useButtonToActivate="false"
  >
    <template v-slot:title>
      <svg viewBox="0 0 46 42" v-show="!isLoading" :class="[$style.exportIcon, {
          [$style.exportIconDisabled]: disabled,
        }]" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="currentColor" fill-rule="evenodd"><path d="M14.077 14.879l6.99-6.991v20.97a2.045 2.045 0 004.091 0V8.395l6.463 7.178a2.047 2.047 0 103.041-2.737L25.082 2.19l-.019-.016-1.926-2.14L20.24 2.93l-9.056 9.055a2.047 2.047 0 002.893 2.893"/><path d="M43.454 25.602a2.045 2.045 0 00-2.045 2.046v10.226H4.591V27.647a2.045 2.045 0 00-4.09 0V39.92c0 1.13.915 2.045 2.044 2.045h40.91c1.13 0 2.045-.916 2.045-2.046V27.648c0-1.13-.916-2.046-2.046-2.046"/></g></svg>
      <LoadingIcon
        v-show="isLoading"
        :class="$style.exportLoadingIcon"
      />
    </template>
  </DropDownMenu>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { get } from 'lodash';
import { notify } from 'client/util';
import DropDownMenu from 'client/components/DropDownMenu/DropDownMenu.vue';
import LoadingIcon from 'components/LoadingOverlay/LoadingIcon.vue';
import pluralize from 'pluralize';

const { ExportFileTypes } = Constants;
const { error, success } = Constants.default;

export default {
  name: 'ExportDropDown',

  components: {
    DropDownMenu,
    LoadingIcon,
  },

  props: {
    bottomAlign: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    exportFunction: {
      type: Function,
      required: true,
    },
    itemText: {
      type: String,
      default: 'item',
    },
    successMessage: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    isLoading: false,
  }),

  computed: {
    menuSections() {
      return [{
        menuItems: [
          { label: 'Export JSON', action: () => this.export(ExportFileTypes.json) },
          { label: 'Export CSV', action: () => this.export(ExportFileTypes.csv) },
        ],
      }];
    },
  },

  methods: {
    async export(fileType) {
      this.isLoading = true;

      try {
        const numRowsExported = await this.exportFunction(fileType);
        const numEvents = Number(numRowsExported);
        const message = this.successMessage || `Successfully exported ${numEvents.toLocaleString()} ${pluralize(this.itemText, numEvents)}!`;
        notify(success, message);
        this.$emit('success', { fileType, numEvents });
      } catch (err) {
        const message = this.errorMessage || get(err, 'message', `There was a problem exporting ${pluralize(this.itemText)}`);
        notify(error, message);
        this.$emit('error', { fileType });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped module>
@value (gradientDark1, gradientDark2, gradientDark4) from '~css/colors.css';

.exportDropDown {
  color: gradientDark2;
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  margin-right: 0;
}

.exportIcon,
.exportLoadingIcon {
  fill: gradientDark2;
  margin-right: 4px;
  position: relative;
  top: 1px;
  width: 11px;
}

.exportIcon:focus { outline: none; }
.exportDropDown:hover { color: gradientDark1; }
.exportDropDown:hover .exportIcon { fill: gradientDark1; }
.exportIconDisabled { fill: gradientDark4; }

</style>
